/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * DISC Chat Interview API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAssessment,
  AdminAssessmentCreated,
  AdminAssessmentDetail,
  AdminCreateAssessmentBody,
  AdminFeedbackItem,
  AdminRatedAssessment,
  ApiKey,
  ApiKeyCreated,
  ApiKeyInput,
  AssessmentCreated,
  AssessmentInput,
  AssessmentResultsResponse,
  AssessmentStatus,
  ChatMessageInput,
  ChatMessageResponse,
  ChatSessionState,
  DiscResultResponse,
  ErrorResponse,
  FinishSessionResponse,
  HealthStatus,
  ListAdminAssessmentsParams,
  ListAdminFeedbacksParams,
  ListAdminRatedAssessmentsParams,
  Participant,
  RateChatSession200,
  RateChatSessionBody,
  SuccessResponse,
  UpdateAssessmentDueDateBody,
  UpdateParticipantInfoBody,
  UpdateParticipantInfoResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetChatSessionUrl = (assessmentToken: string,) => {




  return `/api/chat/${assessmentToken}`
}

/**
 * @summary Get chat session state
 */
export const getChatSession = async (assessmentToken: string, options?: RequestInit): Promise<ChatSessionState> => {

  return customFetch<ChatSessionState>(getGetChatSessionUrl(assessmentToken),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChatSessionQueryKey = (assessmentToken: string,) => {
    return [
    `/api/chat/${assessmentToken}`
    ] as const;
    }


export const getGetChatSessionQueryOptions = <TData = Awaited<ReturnType<typeof getChatSession>>, TError = ErrorType<ErrorResponse>>(assessmentToken: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChatSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatSessionQueryKey(assessmentToken);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatSession>>> = ({ signal }) => getChatSession(assessmentToken, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(assessmentToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChatSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getChatSession>>>
export type GetChatSessionQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get chat session state
 */

export function useGetChatSession<TData = Awaited<ReturnType<typeof getChatSession>>, TError = ErrorType<ErrorResponse>>(
 assessmentToken: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChatSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetChatSessionQueryOptions(assessmentToken,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendChatMessageUrl = (assessmentToken: string,) => {




  return `/api/chat/${assessmentToken}/message`
}

/**
 * @summary Send a message in the chat session
 */
export const sendChatMessage = async (assessmentToken: string,
    chatMessageInput: ChatMessageInput, options?: RequestInit): Promise<ChatMessageResponse> => {

  return customFetch<ChatMessageResponse>(getSendChatMessageUrl(assessmentToken),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      chatMessageInput,)
  }
);}




export const getSendChatMessageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendChatMessage>>, TError,{assessmentToken: string;data: BodyType<ChatMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendChatMessage>>, TError,{assessmentToken: string;data: BodyType<ChatMessageInput>}, TContext> => {

const mutationKey = ['sendChatMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendChatMessage>>, {assessmentToken: string;data: BodyType<ChatMessageInput>}> = (props) => {
          const {assessmentToken,data} = props ?? {};

          return  sendChatMessage(assessmentToken,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendChatMessage>>>
    export type SendChatMessageMutationBody = BodyType<ChatMessageInput>
    export type SendChatMessageMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Send a message in the chat session
 */
export const useSendChatMessage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendChatMessage>>, TError,{assessmentToken: string;data: BodyType<ChatMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendChatMessage>>,
        TError,
        {assessmentToken: string;data: BodyType<ChatMessageInput>},
        TContext
      > => {
      return useMutation(getSendChatMessageMutationOptions(options));
    }

export const getUpdateParticipantInfoUrl = (assessmentToken: string,) => {




  return `/api/chat/${assessmentToken}/participant-info`
}

/**
 * @summary Set participant name and e-mail for the session
 */
export const updateParticipantInfo = async (assessmentToken: string,
    updateParticipantInfoBody: UpdateParticipantInfoBody, options?: RequestInit): Promise<UpdateParticipantInfoResponse> => {

  return customFetch<UpdateParticipantInfoResponse>(getUpdateParticipantInfoUrl(assessmentToken),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateParticipantInfoBody,)
  }
);}




export const getUpdateParticipantInfoMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateParticipantInfo>>, TError,{assessmentToken: string;data: BodyType<UpdateParticipantInfoBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateParticipantInfo>>, TError,{assessmentToken: string;data: BodyType<UpdateParticipantInfoBody>}, TContext> => {

const mutationKey = ['updateParticipantInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateParticipantInfo>>, {assessmentToken: string;data: BodyType<UpdateParticipantInfoBody>}> = (props) => {
          const {assessmentToken,data} = props ?? {};

          return  updateParticipantInfo(assessmentToken,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateParticipantInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateParticipantInfo>>>
    export type UpdateParticipantInfoMutationBody = BodyType<UpdateParticipantInfoBody>
    export type UpdateParticipantInfoMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Set participant name and e-mail for the session
 */
export const useUpdateParticipantInfo = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateParticipantInfo>>, TError,{assessmentToken: string;data: BodyType<UpdateParticipantInfoBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateParticipantInfo>>,
        TError,
        {assessmentToken: string;data: BodyType<UpdateParticipantInfoBody>},
        TContext
      > => {
      return useMutation(getUpdateParticipantInfoMutationOptions(options));
    }

export const getStartChatSessionUrl = (assessmentToken: string,) => {




  return `/api/chat/${assessmentToken}/start`
}

/**
 * @summary Auto-start — generates the first AI message for the current block (idempotent)
 */
export const startChatSession = async (assessmentToken: string, options?: RequestInit): Promise<ChatSessionState> => {

  return customFetch<ChatSessionState>(getStartChatSessionUrl(assessmentToken),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartChatSessionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startChatSession>>, TError,{assessmentToken: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startChatSession>>, TError,{assessmentToken: string}, TContext> => {

const mutationKey = ['startChatSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startChatSession>>, {assessmentToken: string}> = (props) => {
          const {assessmentToken} = props ?? {};

          return  startChatSession(assessmentToken,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartChatSessionMutationResult = NonNullable<Awaited<ReturnType<typeof startChatSession>>>

    export type StartChatSessionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Auto-start — generates the first AI message for the current block (idempotent)
 */
export const useStartChatSession = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startChatSession>>, TError,{assessmentToken: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startChatSession>>,
        TError,
        {assessmentToken: string},
        TContext
      > => {
      return useMutation(getStartChatSessionMutationOptions(options));
    }

export const getFinishChatSessionUrl = (assessmentToken: string,) => {




  return `/api/chat/${assessmentToken}/finish`
}

/**
 * @summary Finish the interview after 12 blocks completed
 */
export const finishChatSession = async (assessmentToken: string, options?: RequestInit): Promise<FinishSessionResponse> => {

  return customFetch<FinishSessionResponse>(getFinishChatSessionUrl(assessmentToken),
  {
    ...options,
    method: 'POST'


  }
);}




export const getFinishChatSessionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishChatSession>>, TError,{assessmentToken: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finishChatSession>>, TError,{assessmentToken: string}, TContext> => {

const mutationKey = ['finishChatSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishChatSession>>, {assessmentToken: string}> = (props) => {
          const {assessmentToken} = props ?? {};

          return  finishChatSession(assessmentToken,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishChatSessionMutationResult = NonNullable<Awaited<ReturnType<typeof finishChatSession>>>

    export type FinishChatSessionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Finish the interview after 12 blocks completed
 */
export const useFinishChatSession = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishChatSession>>, TError,{assessmentToken: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finishChatSession>>,
        TError,
        {assessmentToken: string},
        TContext
      > => {
      return useMutation(getFinishChatSessionMutationOptions(options));
    }

export const getRateChatSessionUrl = (assessmentToken: string,) => {




  return `/api/chat/${assessmentToken}/rate`
}

/**
 * @summary Submit a participant satisfaction rating after interview completion
 */
export const rateChatSession = async (assessmentToken: string,
    rateChatSessionBody: RateChatSessionBody, options?: RequestInit): Promise<RateChatSession200> => {

  return customFetch<RateChatSession200>(getRateChatSessionUrl(assessmentToken),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rateChatSessionBody,)
  }
);}




export const getRateChatSessionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rateChatSession>>, TError,{assessmentToken: string;data: BodyType<RateChatSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rateChatSession>>, TError,{assessmentToken: string;data: BodyType<RateChatSessionBody>}, TContext> => {

const mutationKey = ['rateChatSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rateChatSession>>, {assessmentToken: string;data: BodyType<RateChatSessionBody>}> = (props) => {
          const {assessmentToken,data} = props ?? {};

          return  rateChatSession(assessmentToken,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RateChatSessionMutationResult = NonNullable<Awaited<ReturnType<typeof rateChatSession>>>
    export type RateChatSessionMutationBody = BodyType<RateChatSessionBody>
    export type RateChatSessionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit a participant satisfaction rating after interview completion
 */
export const useRateChatSession = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rateChatSession>>, TError,{assessmentToken: string;data: BodyType<RateChatSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rateChatSession>>,
        TError,
        {assessmentToken: string;data: BodyType<RateChatSessionBody>},
        TContext
      > => {
      return useMutation(getRateChatSessionMutationOptions(options));
    }

export const getCreateAssessmentUrl = (companyId: string,
    participantId: string,) => {




  return `/api/v1/companies/${companyId}/participants/${participantId}/assessments`
}

/**
 * @summary Create a new assessment for a participant
 */
export const createAssessment = async (companyId: string,
    participantId: string,
    assessmentInput: AssessmentInput, options?: RequestInit): Promise<AssessmentCreated> => {

  return customFetch<AssessmentCreated>(getCreateAssessmentUrl(companyId,participantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assessmentInput,)
  }
);}




export const getCreateAssessmentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssessment>>, TError,{companyId: string;participantId: string;data: BodyType<AssessmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssessment>>, TError,{companyId: string;participantId: string;data: BodyType<AssessmentInput>}, TContext> => {

const mutationKey = ['createAssessment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssessment>>, {companyId: string;participantId: string;data: BodyType<AssessmentInput>}> = (props) => {
          const {companyId,participantId,data} = props ?? {};

          return  createAssessment(companyId,participantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAssessment>>>
    export type CreateAssessmentMutationBody = BodyType<AssessmentInput>
    export type CreateAssessmentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a new assessment for a participant
 */
export const useCreateAssessment = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssessment>>, TError,{companyId: string;participantId: string;data: BodyType<AssessmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAssessment>>,
        TError,
        {companyId: string;participantId: string;data: BodyType<AssessmentInput>},
        TContext
      > => {
      return useMutation(getCreateAssessmentMutationOptions(options));
    }

export const getGetAssessmentUrl = (companyId: string,
    participantId: string,
    assessmentId: string,) => {




  return `/api/v1/companies/${companyId}/participants/${participantId}/assessments/${assessmentId}`
}

/**
 * @summary Get assessment status and details
 */
export const getAssessment = async (companyId: string,
    participantId: string,
    assessmentId: string, options?: RequestInit): Promise<AssessmentStatus> => {

  return customFetch<AssessmentStatus>(getGetAssessmentUrl(companyId,participantId,assessmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssessmentQueryKey = (companyId: string,
    participantId: string,
    assessmentId: string,) => {
    return [
    `/api/v1/companies/${companyId}/participants/${participantId}/assessments/${assessmentId}`
    ] as const;
    }


export const getGetAssessmentQueryOptions = <TData = Awaited<ReturnType<typeof getAssessment>>, TError = ErrorType<ErrorResponse>>(companyId: string,
    participantId: string,
    assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssessment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssessmentQueryKey(companyId,participantId,assessmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessment>>> = ({ signal }) => getAssessment(companyId,participantId,assessmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(companyId && participantId && assessmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssessment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssessmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAssessment>>>
export type GetAssessmentQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get assessment status and details
 */

export function useGetAssessment<TData = Awaited<ReturnType<typeof getAssessment>>, TError = ErrorType<ErrorResponse>>(
 companyId: string,
    participantId: string,
    assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssessment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssessmentQueryOptions(companyId,participantId,assessmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getResendAssessmentInviteUrl = (companyId: string,
    participantId: string,
    assessmentId: string,) => {




  return `/api/v1/companies/${companyId}/participants/${participantId}/assessments/${assessmentId}/resend-invite`
}

/**
 * @summary Resend interview invite email for an assessment
 */
export const resendAssessmentInvite = async (companyId: string,
    participantId: string,
    assessmentId: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getResendAssessmentInviteUrl(companyId,participantId,assessmentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendAssessmentInviteMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAssessmentInvite>>, TError,{companyId: string;participantId: string;assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendAssessmentInvite>>, TError,{companyId: string;participantId: string;assessmentId: string}, TContext> => {

const mutationKey = ['resendAssessmentInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAssessmentInvite>>, {companyId: string;participantId: string;assessmentId: string}> = (props) => {
          const {companyId,participantId,assessmentId} = props ?? {};

          return  resendAssessmentInvite(companyId,participantId,assessmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAssessmentInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendAssessmentInvite>>>

    export type ResendAssessmentInviteMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Resend interview invite email for an assessment
 */
export const useResendAssessmentInvite = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAssessmentInvite>>, TError,{companyId: string;participantId: string;assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendAssessmentInvite>>,
        TError,
        {companyId: string;participantId: string;assessmentId: string},
        TContext
      > => {
      return useMutation(getResendAssessmentInviteMutationOptions(options));
    }

export const getUpdateAssessmentDueDateUrl = (companyId: string,
    participantId: string,
    assessmentId: string,) => {




  return `/api/v1/companies/${companyId}/participants/${participantId}/assessments/${assessmentId}/due-date`
}

/**
 * @summary Update the due date of an assessment
 */
export const updateAssessmentDueDate = async (companyId: string,
    participantId: string,
    assessmentId: string,
    updateAssessmentDueDateBody: UpdateAssessmentDueDateBody, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getUpdateAssessmentDueDateUrl(companyId,participantId,assessmentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAssessmentDueDateBody,)
  }
);}




export const getUpdateAssessmentDueDateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssessmentDueDate>>, TError,{companyId: string;participantId: string;assessmentId: string;data: BodyType<UpdateAssessmentDueDateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssessmentDueDate>>, TError,{companyId: string;participantId: string;assessmentId: string;data: BodyType<UpdateAssessmentDueDateBody>}, TContext> => {

const mutationKey = ['updateAssessmentDueDate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssessmentDueDate>>, {companyId: string;participantId: string;assessmentId: string;data: BodyType<UpdateAssessmentDueDateBody>}> = (props) => {
          const {companyId,participantId,assessmentId,data} = props ?? {};

          return  updateAssessmentDueDate(companyId,participantId,assessmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssessmentDueDateMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssessmentDueDate>>>
    export type UpdateAssessmentDueDateMutationBody = BodyType<UpdateAssessmentDueDateBody>
    export type UpdateAssessmentDueDateMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update the due date of an assessment
 */
export const useUpdateAssessmentDueDate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssessmentDueDate>>, TError,{companyId: string;participantId: string;assessmentId: string;data: BodyType<UpdateAssessmentDueDateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAssessmentDueDate>>,
        TError,
        {companyId: string;participantId: string;assessmentId: string;data: BodyType<UpdateAssessmentDueDateBody>},
        TContext
      > => {
      return useMutation(getUpdateAssessmentDueDateMutationOptions(options));
    }

export const getListCompanyParticipantsUrl = (companyId: string,) => {




  return `/api/v1/companies/${companyId}/participants`
}

/**
 * @summary List all participants for a company
 */
export const listCompanyParticipants = async (companyId: string, options?: RequestInit): Promise<Participant[]> => {

  return customFetch<Participant[]>(getListCompanyParticipantsUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanyParticipantsQueryKey = (companyId: string,) => {
    return [
    `/api/v1/companies/${companyId}/participants`
    ] as const;
    }


export const getListCompanyParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyParticipants>>, TError = ErrorType<ErrorResponse>>(companyId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanyParticipants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompanyParticipantsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyParticipants>>> = ({ signal }) => listCompanyParticipants(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyParticipants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCompanyParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyParticipants>>>
export type ListCompanyParticipantsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all participants for a company
 */

export function useListCompanyParticipants<TData = Awaited<ReturnType<typeof listCompanyParticipants>>, TError = ErrorType<ErrorResponse>>(
 companyId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanyParticipants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCompanyParticipantsQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAssessmentResultsUrl = (companyId: string,
    participantId: string,
    assessmentId: string,) => {




  return `/api/v1/companies/${companyId}/participants/${participantId}/assessments/${assessmentId}/results`
}

/**
 * @summary Get DISC results for a specific assessment
 */
export const getAssessmentResults = async (companyId: string,
    participantId: string,
    assessmentId: string, options?: RequestInit): Promise<AssessmentResultsResponse> => {

  return customFetch<AssessmentResultsResponse>(getGetAssessmentResultsUrl(companyId,participantId,assessmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssessmentResultsQueryKey = (companyId: string,
    participantId: string,
    assessmentId: string,) => {
    return [
    `/api/v1/companies/${companyId}/participants/${participantId}/assessments/${assessmentId}/results`
    ] as const;
    }


export const getGetAssessmentResultsQueryOptions = <TData = Awaited<ReturnType<typeof getAssessmentResults>>, TError = ErrorType<ErrorResponse>>(companyId: string,
    participantId: string,
    assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssessmentResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssessmentResultsQueryKey(companyId,participantId,assessmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentResults>>> = ({ signal }) => getAssessmentResults(companyId,participantId,assessmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(companyId && participantId && assessmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssessmentResults>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssessmentResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssessmentResults>>>
export type GetAssessmentResultsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get DISC results for a specific assessment
 */

export function useGetAssessmentResults<TData = Awaited<ReturnType<typeof getAssessmentResults>>, TError = ErrorType<ErrorResponse>>(
 companyId: string,
    participantId: string,
    assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssessmentResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssessmentResultsQueryOptions(companyId,participantId,assessmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetParticipantResultsUrl = (companyId: string,
    participantId: string,) => {




  return `/api/v1/companies/${companyId}/participants/${participantId}/results`
}

/**
 * @summary Get latest DISC results for a participant
 */
export const getParticipantResults = async (companyId: string,
    participantId: string, options?: RequestInit): Promise<DiscResultResponse> => {

  return customFetch<DiscResultResponse>(getGetParticipantResultsUrl(companyId,participantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetParticipantResultsQueryKey = (companyId: string,
    participantId: string,) => {
    return [
    `/api/v1/companies/${companyId}/participants/${participantId}/results`
    ] as const;
    }


export const getGetParticipantResultsQueryOptions = <TData = Awaited<ReturnType<typeof getParticipantResults>>, TError = ErrorType<ErrorResponse>>(companyId: string,
    participantId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getParticipantResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParticipantResultsQueryKey(companyId,participantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getParticipantResults>>> = ({ signal }) => getParticipantResults(companyId,participantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(companyId && participantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getParticipantResults>>, TError, TData> & { queryKey: QueryKey }
}

export type GetParticipantResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getParticipantResults>>>
export type GetParticipantResultsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get latest DISC results for a participant
 */

export function useGetParticipantResults<TData = Awaited<ReturnType<typeof getParticipantResults>>, TError = ErrorType<ErrorResponse>>(
 companyId: string,
    participantId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getParticipantResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetParticipantResultsQueryOptions(companyId,participantId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListApiKeysUrl = () => {




  return `/api/admin/api-keys`
}

/**
 * @summary List all API keys
 */
export const listApiKeys = async ( options?: RequestInit): Promise<ApiKey[]> => {

  return customFetch<ApiKey[]>(getListApiKeysUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListApiKeysQueryKey = () => {
    return [
    `/api/admin/api-keys`
    ] as const;
    }


export const getListApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof listApiKeys>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApiKeysQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeys>>> = ({ signal }) => listApiKeys({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listApiKeys>>>
export type ListApiKeysQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all API keys
 */

export function useListApiKeys<TData = Awaited<ReturnType<typeof listApiKeys>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListApiKeysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateApiKeyUrl = () => {




  return `/api/admin/api-keys`
}

/**
 * @summary Create a new API key (raw key shown once)
 */
export const createApiKey = async (apiKeyInput: ApiKeyInput, options?: RequestInit): Promise<ApiKeyCreated> => {

  return customFetch<ApiKeyCreated>(getCreateApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      apiKeyInput,)
  }
);}




export const getCreateApiKeyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,{data: BodyType<ApiKeyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,{data: BodyType<ApiKeyInput>}, TContext> => {

const mutationKey = ['createApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApiKey>>, {data: BodyType<ApiKeyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createApiKey(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createApiKey>>>
    export type CreateApiKeyMutationBody = BodyType<ApiKeyInput>
    export type CreateApiKeyMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a new API key (raw key shown once)
 */
export const useCreateApiKey = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,{data: BodyType<ApiKeyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createApiKey>>,
        TError,
        {data: BodyType<ApiKeyInput>},
        TContext
      > => {
      return useMutation(getCreateApiKeyMutationOptions(options));
    }

export const getRevokeApiKeyUrl = (keyId: string,) => {




  return `/api/admin/api-keys/${keyId}`
}

/**
 * @summary Revoke an API key
 */
export const revokeApiKey = async (keyId: string, options?: RequestInit): Promise<ApiKey> => {

  return customFetch<ApiKey>(getRevokeApiKeyUrl(keyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeApiKeyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,{keyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,{keyId: string}, TContext> => {

const mutationKey = ['revokeApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeApiKey>>, {keyId: string}> = (props) => {
          const {keyId} = props ?? {};

          return  revokeApiKey(keyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeApiKey>>>

    export type RevokeApiKeyMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Revoke an API key
 */
export const useRevokeApiKey = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,{keyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeApiKey>>,
        TError,
        {keyId: string},
        TContext
      > => {
      return useMutation(getRevokeApiKeyMutationOptions(options));
    }

export const getListAdminAssessmentsUrl = (params?: ListAdminAssessmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/assessments?${stringifiedParams}` : `/api/admin/assessments`
}

/**
 * @summary List all sessions (newest first)
 */
export const listAdminAssessments = async (params?: ListAdminAssessmentsParams, options?: RequestInit): Promise<AdminAssessment[]> => {

  return customFetch<AdminAssessment[]>(getListAdminAssessmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAssessmentsQueryKey = (params?: ListAdminAssessmentsParams,) => {
    return [
    `/api/admin/assessments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminAssessmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAssessments>>, TError = ErrorType<ErrorResponse>>(params?: ListAdminAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminAssessmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAssessments>>> = ({ signal }) => listAdminAssessments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAssessments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAssessments>>>
export type ListAdminAssessmentsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all sessions (newest first)
 */

export function useListAdminAssessments<TData = Awaited<ReturnType<typeof listAdminAssessments>>, TError = ErrorType<ErrorResponse>>(
 params?: ListAdminAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminAssessmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAdminAssessmentUrl = () => {




  return `/api/admin/assessments`
}

/**
 * @summary Create a new session from the admin panel
 */
export const createAdminAssessment = async (adminCreateAssessmentBody: AdminCreateAssessmentBody, options?: RequestInit): Promise<AdminAssessmentCreated> => {

  return customFetch<AdminAssessmentCreated>(getCreateAdminAssessmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminCreateAssessmentBody,)
  }
);}




export const getCreateAdminAssessmentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminAssessment>>, TError,{data: BodyType<AdminCreateAssessmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminAssessment>>, TError,{data: BodyType<AdminCreateAssessmentBody>}, TContext> => {

const mutationKey = ['createAdminAssessment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminAssessment>>, {data: BodyType<AdminCreateAssessmentBody>}> = (props) => {
          const {data} = props ?? {};

          return  createAdminAssessment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminAssessment>>>
    export type CreateAdminAssessmentMutationBody = BodyType<AdminCreateAssessmentBody>
    export type CreateAdminAssessmentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a new session from the admin panel
 */
export const useCreateAdminAssessment = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminAssessment>>, TError,{data: BodyType<AdminCreateAssessmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminAssessment>>,
        TError,
        {data: BodyType<AdminCreateAssessmentBody>},
        TContext
      > => {
      return useMutation(getCreateAdminAssessmentMutationOptions(options));
    }

export const getResendAdminAssessmentInviteUrl = (assessmentId: string,) => {




  return `/api/admin/assessments/${assessmentId}/resend-invite`
}

/**
 * @summary Resend interview invite email for a session
 */
export const resendAdminAssessmentInvite = async (assessmentId: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getResendAdminAssessmentInviteUrl(assessmentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendAdminAssessmentInviteMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminAssessmentInvite>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendAdminAssessmentInvite>>, TError,{assessmentId: string}, TContext> => {

const mutationKey = ['resendAdminAssessmentInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAdminAssessmentInvite>>, {assessmentId: string}> = (props) => {
          const {assessmentId} = props ?? {};

          return  resendAdminAssessmentInvite(assessmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAdminAssessmentInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendAdminAssessmentInvite>>>

    export type ResendAdminAssessmentInviteMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Resend interview invite email for a session
 */
export const useResendAdminAssessmentInvite = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminAssessmentInvite>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendAdminAssessmentInvite>>,
        TError,
        {assessmentId: string},
        TContext
      > => {
      return useMutation(getResendAdminAssessmentInviteMutationOptions(options));
    }

export const getReopenAdminAssessmentUrl = (assessmentId: string,) => {




  return `/api/admin/assessments/${assessmentId}/reopen`
}

/**
 * @summary Reopen an expired assessment (reset to pending, extend expiry 7 days)
 */
export const reopenAdminAssessment = async (assessmentId: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getReopenAdminAssessmentUrl(assessmentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReopenAdminAssessmentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenAdminAssessment>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenAdminAssessment>>, TError,{assessmentId: string}, TContext> => {

const mutationKey = ['reopenAdminAssessment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenAdminAssessment>>, {assessmentId: string}> = (props) => {
          const {assessmentId} = props ?? {};

          return  reopenAdminAssessment(assessmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenAdminAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof reopenAdminAssessment>>>

    export type ReopenAdminAssessmentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Reopen an expired assessment (reset to pending, extend expiry 7 days)
 */
export const useReopenAdminAssessment = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenAdminAssessment>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reopenAdminAssessment>>,
        TError,
        {assessmentId: string},
        TContext
      > => {
      return useMutation(getReopenAdminAssessmentMutationOptions(options));
    }

export const getResendPartnersWebhookUrl = (assessmentId: string,) => {




  return `/api/admin/assessments/${assessmentId}/resend-partners-webhook`
}

/**
 * @summary Manually resend the assessment.completed webhook to the partners endpoint
 */
export const resendPartnersWebhook = async (assessmentId: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getResendPartnersWebhookUrl(assessmentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendPartnersWebhookMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPartnersWebhook>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendPartnersWebhook>>, TError,{assessmentId: string}, TContext> => {

const mutationKey = ['resendPartnersWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendPartnersWebhook>>, {assessmentId: string}> = (props) => {
          const {assessmentId} = props ?? {};

          return  resendPartnersWebhook(assessmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendPartnersWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof resendPartnersWebhook>>>

    export type ResendPartnersWebhookMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Manually resend the assessment.completed webhook to the partners endpoint
 */
export const useResendPartnersWebhook = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPartnersWebhook>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendPartnersWebhook>>,
        TError,
        {assessmentId: string},
        TContext
      > => {
      return useMutation(getResendPartnersWebhookMutationOptions(options));
    }

export const getNotifyPartnersCreatedUrl = (assessmentId: string,) => {




  return `/api/admin/assessments/${assessmentId}/notify-partners-created`
}

/**
 * @summary Manually send assessment.created webhook to partners for a pending or in-progress assessment
 */
export const notifyPartnersCreated = async (assessmentId: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getNotifyPartnersCreatedUrl(assessmentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getNotifyPartnersCreatedMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPartnersCreated>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyPartnersCreated>>, TError,{assessmentId: string}, TContext> => {

const mutationKey = ['notifyPartnersCreated'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyPartnersCreated>>, {assessmentId: string}> = (props) => {
          const {assessmentId} = props ?? {};

          return  notifyPartnersCreated(assessmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyPartnersCreatedMutationResult = NonNullable<Awaited<ReturnType<typeof notifyPartnersCreated>>>

    export type NotifyPartnersCreatedMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Manually send assessment.created webhook to partners for a pending or in-progress assessment
 */
export const useNotifyPartnersCreated = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPartnersCreated>>, TError,{assessmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyPartnersCreated>>,
        TError,
        {assessmentId: string},
        TContext
      > => {
      return useMutation(getNotifyPartnersCreatedMutationOptions(options));
    }

export const getGetAdminAssessmentReportUrl = (assessmentId: string,) => {




  return `/api/admin/assessments/${assessmentId}/report`
}

/**
 * @summary Download DISC PDF report for a session (admin-authenticated)
 */
export const getAdminAssessmentReport = async (assessmentId: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetAdminAssessmentReportUrl(assessmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAssessmentReportQueryKey = (assessmentId: string,) => {
    return [
    `/api/admin/assessments/${assessmentId}/report`
    ] as const;
    }


export const getGetAdminAssessmentReportQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAssessmentReport>>, TError = ErrorType<ErrorResponse>>(assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessmentReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAssessmentReportQueryKey(assessmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAssessmentReport>>> = ({ signal }) => getAdminAssessmentReport(assessmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(assessmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessmentReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAssessmentReportQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAssessmentReport>>>
export type GetAdminAssessmentReportQueryError = ErrorType<ErrorResponse>


/**
 * @summary Download DISC PDF report for a session (admin-authenticated)
 */

export function useGetAdminAssessmentReport<TData = Awaited<ReturnType<typeof getAdminAssessmentReport>>, TError = ErrorType<ErrorResponse>>(
 assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessmentReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAssessmentReportQueryOptions(assessmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminFeedbacksUrl = (params?: ListAdminFeedbacksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/feedbacks?${stringifiedParams}` : `/api/admin/feedbacks`
}

/**
 * @summary List all general feedback submissions
 */
export const listAdminFeedbacks = async (params?: ListAdminFeedbacksParams, options?: RequestInit): Promise<AdminFeedbackItem[]> => {

  return customFetch<AdminFeedbackItem[]>(getListAdminFeedbacksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminFeedbacksQueryKey = (params?: ListAdminFeedbacksParams,) => {
    return [
    `/api/admin/feedbacks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof listAdminFeedbacks>>, TError = ErrorType<ErrorResponse>>(params?: ListAdminFeedbacksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminFeedbacks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminFeedbacksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminFeedbacks>>> = ({ signal }) => listAdminFeedbacks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminFeedbacks>>>
export type ListAdminFeedbacksQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all general feedback submissions
 */

export function useListAdminFeedbacks<TData = Awaited<ReturnType<typeof listAdminFeedbacks>>, TError = ErrorType<ErrorResponse>>(
 params?: ListAdminFeedbacksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminFeedbacks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminFeedbacksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminRatedAssessmentsUrl = (params?: ListAdminRatedAssessmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/assessments/rated?${stringifiedParams}` : `/api/admin/assessments/rated`
}

/**
 * @summary List sessions that have a participant rating
 */
export const listAdminRatedAssessments = async (params?: ListAdminRatedAssessmentsParams, options?: RequestInit): Promise<AdminRatedAssessment[]> => {

  return customFetch<AdminRatedAssessment[]>(getListAdminRatedAssessmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRatedAssessmentsQueryKey = (params?: ListAdminRatedAssessmentsParams,) => {
    return [
    `/api/admin/assessments/rated`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminRatedAssessmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRatedAssessments>>, TError = ErrorType<ErrorResponse>>(params?: ListAdminRatedAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminRatedAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRatedAssessmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRatedAssessments>>> = ({ signal }) => listAdminRatedAssessments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRatedAssessments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminRatedAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRatedAssessments>>>
export type ListAdminRatedAssessmentsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List sessions that have a participant rating
 */

export function useListAdminRatedAssessments<TData = Awaited<ReturnType<typeof listAdminRatedAssessments>>, TError = ErrorType<ErrorResponse>>(
 params?: ListAdminRatedAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminRatedAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminRatedAssessmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminAssessmentUrl = (assessmentId: string,) => {




  return `/api/admin/assessments/${assessmentId}`
}

/**
 * @summary Get session detail with transcript and DISC result
 */
export const getAdminAssessment = async (assessmentId: string, options?: RequestInit): Promise<AdminAssessmentDetail> => {

  return customFetch<AdminAssessmentDetail>(getGetAdminAssessmentUrl(assessmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAssessmentQueryKey = (assessmentId: string,) => {
    return [
    `/api/admin/assessments/${assessmentId}`
    ] as const;
    }


export const getGetAdminAssessmentQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAssessment>>, TError = ErrorType<ErrorResponse>>(assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAssessmentQueryKey(assessmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAssessment>>> = ({ signal }) => getAdminAssessment(assessmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(assessmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAssessmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAssessment>>>
export type GetAdminAssessmentQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get session detail with transcript and DISC result
 */

export function useGetAdminAssessment<TData = Awaited<ReturnType<typeof getAdminAssessment>>, TError = ErrorType<ErrorResponse>>(
 assessmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAssessmentQueryOptions(assessmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







